import React from 'react';
import { SdmDialog, SdmTypography } from 'components';
import { Controller } from 'react-hook-form';
import CustomRadioButton from '../styledComponents/CustomRadioButton';

function SaveOptionsDialog({ onClose, onAgree, i18n, options, control }) {
  const renderTitle = () => {
    return (
      <div style={{ width: '100%', marginTop: 16 }}>
        <SdmTypography
          variant={'h1'}
          style={{ textAlign: 'center', marginTop: 20, marginBottom: 0 }}
        >
          {i18n.title}
        </SdmTypography>
      </div>
    );
  };
  return (
    <SdmDialog
      open
      onClose={onClose}
      title={renderTitle()}
      agreeText={i18n.agree}
      onAgree={onAgree}
      paperStyle={{
        borderRadius: 15,
        width: 410,
        paddingBottom: 16,
        margin: 0,
      }}
      closeIconContainerStyle={{
        top: 15,
        right: 20,
        transform: 'scale(1.5)',
      }}
      actionContainerStyle={{ justifyContent: 'center' }}
      actionStyle={{ height: 40, width: 180, margin: 0 }}
      actionTextStyle={{ fontSize: 20 }}
      titleStyle={{ padding: 0 }}
      contentStyle={{
        paddingTop: 16,
        paddingBottom: 22,
        flex: 'none',
        margin: '0 auto',
      }}
      showTitleDivider={false}
      handleBody={false}
    >
      <div
        style={{
          textAlign: 'center',
          fontSize: 20,
          marginBottom: 20,
        }}
      >
        {i18n.body}
      </div>
      <Controller
        name={'save'}
        control={control}
        defaultValue={'0'}
        render={(props) => (
          <CustomRadioButton
            options={options}
            value={props.value}
            onChange={(e) => {
              props.onChange(e.target.value);
            }}
            radioGroupOnly={true}
          />
        )}
      />
    </SdmDialog>
  );
}

export default SaveOptionsDialog;
